var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_725_1183",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_725_1183",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAArwAAAK8BK7AVuQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAG/SURBVEiJrdW9axRRFAXw391sMKISZFFTCyqiFlYWppZgYWEqC20U/wTBytJgaydok8IyjYWdBksrCzUWfgsRgpgUuhaRZzFvv8bZ3dHshcs9c96ZOW/efW9GSkk5cRcPEFXjFfpbWMG+v8YqxAeRch6tafAz68+Vx5oRsYgbmFXEFb1oRcSa0XENjYwbEfECu7CFO7DeN+OE+SF4WC7gVwVOWG9gbsTs0pjZwxS2M94ujc01K244i9vYi5M1DC4olvgU2orl6UZUzPI3Hile9SKma5g8wwecR2ucwUSjs0QPcW/Cz76OSx2DTymlp5N8ekQs0Nu//3LjYkSs5byfuSd93Ol+fdUuGhcHcCzjr7kex6GMZ/vF/2PwQ3FK4Xuu3zCTcXtHBimlZSyXuBPD9AM9iIjLEbGZcyVzL/u4M3U0o95gj94a7s+11cftrqkZarCBNxm/zfU1NjPeqqkZiISl/F0PRbNm0MzcdIerq8ncElL5HFxV7II2HmfufYeLiPmamm6UDZoVuMzV0VRf4CNWM36e66reIdpQNHGcZiC6PZhkyj0IfM4m78rOO4zDiCm8whHFH6w5wfyCm38AK6s1E8tYD3IAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.49f95ab66cbaf77e6e8b6123d8011ca3.svg";
export { ForwardRef as ReactComponent };